<template>
    <v-row v-resize="onResize" no-gutters class="fill-height">
        <v-col
            cols="12"
            md="3"
            sm="12"
            lg="3"
            ref="menu"
            class="border-right d-flex flex-column flex-nowrap"
            :style="{ height: `${height}px` }"
        >
            <div
                v-if="loading"
                class="d-flex align-center justify-center flex-grow-1"
            >
                <v-progress-circular color="primary" indeterminate />
            </div>
            <v-list v-else class="overflow-y-auto pa-0">
                <template v-if="localSettings.length > 0">
                    <v-list-item-group>
                        <v-list-item
                            v-for="(setting, i) in localSettings"
                            :key="setting.id || setting.name || i"
                            color="primary"
                            three-line
                            @click="hide"
                            link
                            :to="{
                                name:
                                    setting.nameRoute ||
                                    setting.name.toLowerCase(),
                                params: { setting: setting },
                            }"
                            :class="{
                                'border-bottom': i < localSettings.length - 1,
                            }"
                        >
                            <v-list-item-content>
                                <v-list-item-title class="mt-3">{{
                                    setting.name == 'Client'
                                        ? 'Client Portal'
                                        : setting.name
                                }}</v-list-item-title>
                                <v-list-item class="pa-0">
                                    <v-list-item-icon class="mt-2 mb-0">
                                        <v-icon>mdi-cog-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-subtitle class="mt-0">
                                        Settings
                                    </v-list-item-subtitle>
                                </v-list-item>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </template>
            </v-list>
        </v-col>
        <v-col
            sm="0"
            cols="12"
            md="9"
            lg="9"
            class="overflow-y-auto"
            :style="{ height: `${height}px` }"
        >
            <router-view @show="show" />
        </v-col>
    </v-row>
</template>

<script>
import API from '@/services/api'
import { storage } from '@/services/firebase'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
    name: 'Settings',
    data() {
        return {
            loading: false,
            height: 0,
            company: JSON.parse(localStorage.getItem('company')),
            folder: 'company_logo',
            loadingError: false,
            errorMsg: null,
            sortOptions: [
                {
                    text: 'Name',
                    value: 'name',
                },
            ],
            localSettings: [],
        }
    },

    computed: {
        ...mapState(['settings', 'userRef']),
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        onResize() {
            this.height =
                window.innerHeight - this.$vuetify.application.top - 40
        },
        ...mapActions(['addSettingsAction']),
        hide() {
            if (this.$vuetify.breakpoint.smAndDown) {
                this.$refs.menu.classList.remove('d-flex')
                this.$refs.menu.classList.add('d-none')
            }
        },
        show() {
            this.$refs.menu.classList.remove('d-none')
            this.$refs.menu.classList.add('d-flex')
        },
        buildOrderSettings(settings) {
            const orderSettings = []

            const company = settings.find(x => x.name == 'Company')
            if (company) {
                orderSettings.push(company)
            }

            const exchange = settings.find(x => x.name == 'Exchange')
            if (exchange) {
                orderSettings.push(exchange)
            }

            const permissions = settings.find(x => x.name == 'Permissions')
            if (permissions) {
                orderSettings.push(permissions)
            }

            const quotes = settings.find(x => x.name == 'Quotes')
            if (quotes) {
                orderSettings.push(quotes)
            }

            // Add Calculations if user has permission
            const calculations = this.userRef.permissions.find(
                x => x == 'calculations'
            )
            if (calculations) {
                const item = settings.find(x => x.name == 'Calculations')
                if (item) {
                    orderSettings.push(item)
                }
            }
            const processes = settings.find(x => x.name == 'Processes')
            const products = settings.find(x => x.name == 'Products')

            const projectsSettings = settings.find(x => x.name == 'Projects')
            if (projectsSettings) {
                orderSettings.push({
                    name: 'Projects',
                    nameRoute: 'projectsSettings',
                    projectsSettings,
                })
            }

            const finish = settings.find(x => x.name == 'FinishAndUCCode')
            if (finish) {
                orderSettings.push(finish)
            }

            const HSCodeSettings = settings.find(x => x.name == 'HSCodes')
            if (HSCodeSettings) {
                orderSettings.push(HSCodeSettings)
            }

            const invoicing = settings.find(x => x.name == 'Invoicing')
            if (invoicing) {
                orderSettings.push(invoicing)
            }

            const quality = settings.find(x => x.name == 'Quality')

            if (processes) {
                orderSettings.push({
                    name: 'Machines',
                    nameRoute: 'machinesSettings',
                    id: processes.id,
                })
            }

            const productTypes = settings.find(x => x.name == 'ProductTypes')

            orderSettings.push({
                name: 'WorkOrders',
                nameRoute: 'workOrderSettings',
                processes: processes || {},
                products: products || {},
                productTypes: productTypes || {},
            })

            orderSettings.push({
                name: 'Quality',
                nameRoute: 'qualitySettings',
                quality: quality || {},
            })

            orderSettings.push({
                name: 'Operators',
                nameRoute: 'operators',
            })

            const specialMaterials = settings.find(
                x => x.name == 'SpecialMaterials'
            )
            if (specialMaterials) {
                orderSettings.push(specialMaterials)
            }

            const notificationSettings = settings.find(
                x => x.name == 'Notification'
            )
            if (notificationSettings) {
                orderSettings.push(notificationSettings)
            }

            const InputSetting = settings.find(x => x.name == 'Materials')
            if (InputSetting) {
                orderSettings.push(InputSetting)
            }

            return orderSettings
        },
    },
    watch: {
        localSettings: function(newSet) {
            if (!newSet || newSet.length === 0) {
                return
            }

            const params = this.$router.currentRoute.params.setting
            const route = this.$router.currentRoute.name

            if (!params) {
                if (
                    route == 'settingsCosts' ||
                    route == 'settingsCommercial' ||
                    route == 'settingsImage' ||
                    route == 'settingsUnits' ||
                    route == 'emailBodySettings' ||
                    route == 'settingsReasons'
                ) {
                    const setting = newSet.find(i => i.name == 'Quotes')
                    this.$router.currentRoute.params.setting = setting
                } else if (route == 'settingsCurrencies') {
                    const setting = newSet.find(i => i.name == 'Exchange')
                    this.$router.currentRoute.params.setting = setting
                } else if (route == 'companyGeneralInfo') {
                    const setting = newSet.find(i => i.name == 'Company')
                    this.$router.currentRoute.params.setting = setting
                } else if (route == 'rolesSettings') {
                    const setting = newSet.find(i => i.name == 'Permissions')
                    this.$router.currentRoute.params.setting = setting
                } else if (route == 'operators') {
                    const setting = newSet.find(i => i.name == 'Operators')
                    this.$router.currentRoute.params.setting = setting
                } else if (route == 'products') {
                    const setting = newSet.find(i => i.name == 'Products')
                    this.$router.currentRoute.params.setting = setting
                } else if (route == 'invoicingSettings') {
                    const setting = newSet.find(i => i.name == 'Invoicing')
                    this.$router.currentRoute.params.setting = setting
                } else if (route == 'specialMaterials') {
                    const setting = newSet.find(
                        i => i.name == 'SpecialMaterials'
                    )
                    this.$router.currentRoute.params.setting = setting
                } else if (route == 'notification-settings') {
                    const setting = newSet.find(i => i.name == 'Notification')
                    this.$router.currentRoute.params.setting = setting
                } else if (route == 'quality') {
                    const setting = newSet.find(i => i.name == 'Quality')
                    this.$router.currentRoute.params.setting = setting
                } else if (route == 'client-settings') {
                    const setting = newSet.find(i => i.name == 'Client')
                    this.$router.currentRoute.params.setting = setting
                } else if (route == 'projects') {
                    const setting = newSet.find(i => i.name == 'Projects')
                    this.$router.currentRoute.params.setting = setting
                } else if (route == 'materialSetting') {
                    const setting = newSet.find(i => i.name === 'Materials')
                    this.$router.currentRoute.params.setting = setting
                } else if (route == 'hs-code') {
                    const setting = newSet.find(i => i.name == 'HSCodes')
                    this.$router.currentRoute.params.setting = setting
                } else {
                    const setting = newSet.find(i => i.name == 'Calculations')
                    this.$router.currentRoute.params.setting = setting
                }
            }
        },
    },
    async created() {
        try {
            this.loadingError = false
            this.errorMsg = null
            this.loading = true
            const {
                data: { settings },
            } = await API.getSettings()
            const indexImage = settings.findIndex(x => x.name == 'Company')
            if (settings[indexImage].generalInfo.image) {
                const path = `${this.company}/${this.folder}`
                const storageRef = storage().ref(path)
                const profilePicRef = storageRef.child(
                    settings[indexImage].generalInfo.image.file
                )
                settings[
                    indexImage
                ].generalInfo.image.imageURL = await profilePicRef.getDownloadURL()
            }
            let orderSettings = this.buildOrderSettings(settings)

            // Handle HSCodes if it doesn't exist
            const hasHSCodes = orderSettings.some(s => s.name == 'HSCodes')
            if (!hasHSCodes) {
                const hsCodeSetting = await API.createHSCode()
                // Insert HSCodes after FinishAndUCCode
                const finishIndex = orderSettings.findIndex(
                    s => s.name == 'FinishAndUCCode'
                )
                if (finishIndex >= 0) {
                    orderSettings.splice(finishIndex + 1, 0, hsCodeSetting)
                } else {
                    orderSettings.push(hsCodeSetting)
                }
            }

            let clientSettings = settings.find(x => x.name == 'Client')
            if (!clientSettings) {
                clientSettings = await API.createClientSetting()
            }
            orderSettings.push(clientSettings)

            // Filter out any undefined values
            const filteredOrderSettings = orderSettings.filter(
                setting => setting != null && setting != undefined
            )

            this.localSettings = filteredOrderSettings

            // Update store for other components to use
            this.addSettingsAction([...filteredOrderSettings])
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
}
</script>
<style scoped>
.border-right {
    border-width: 0 1px 0 0;
    border-style: solid;
    border-color: #f0f0f0;
}
.border-bottom {
    border-width: 0 0 1px 0;
    border-style: solid;
    border-color: #f0f0f0;
}
</style>
